function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 60,
  fill: "#13182C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.0015 30.0233L44.6707 22.7288L58.1637 29.9704L44.6824 37.2712L31.0015 30.0233Z",
  fill: "#009F42"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.0015 30.0233L44.6707 22.7288L58.1637 29.9704L44.6824 37.2712L31.0015 30.0233Z",
  fill: "#01C853"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M44.6714 22.7288L58.1644 29.9704L44.6831 37.2712L44.6714 22.7288Z",
  fill: "#009F42"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M44.6714 31.1419L58.1644 29.9702L44.6831 37.2711L44.6714 31.1419H44.6714Z",
  fill: "#007831"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M44.6707 31.1419L31.0015 30.0232L44.659 37.2711L44.6707 31.1419H44.6707Z",
  fill: "#009F42"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M31 31.9629C35.7881 34.5026 40.7773 37.1646 44.6402 39.2228L58.1688 31.9649C53.2705 39.2437 49.1904 45.2982 44.6401 51.9996C40.0842 45.3123 35.0501 37.9308 31 31.9629Z",
  fill: "#009F42"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M31 31.9629C35.7881 34.5026 40.7773 37.1646 44.6402 39.2228L58.1688 31.9649C53.2705 39.2437 49.1904 45.2982 44.6401 51.9996C40.0842 45.3123 35.0501 37.9308 31 31.9629Z",
  fill: "#01C853"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M44.6402 39.2232L58.1689 31.9653C53.2705 39.2441 44.6401 52 44.6401 52L44.6402 39.2232Z",
  fill: "#009F42"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M44.6402 39.2232L58.1689 31.9653C53.2705 39.2441 49.1904 45.2986 44.6401 52L44.6402 39.2232Z",
  fill: "#009F42"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M44.6379 20.7L31.002 27.8804L44.5787 8L58.1641 27.9238L44.6379 20.7Z",
  fill: "#01C853"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M44.6378 20.7L44.5786 8L58.164 27.9238L44.6378 20.7Z",
  fill: "#009F42"
});

var SvgEtc = function SvgEtc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEtc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ETC.d51b1f0f.svg";
export { ForwardRef as ReactComponent };